
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { Alert, Avatar, Box, Button, Card, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, Grow, IconButton, MenuItem, Snackbar, TextField, Typography } from '@mui/material';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { Eventcalendar, MbscCalendarEvent, MbscEventcalendarView, setOptions, localeEs, formatDate, Popup, MbscEventClickEvent, MbscDateType, CalendarToday, CalendarNext, CalendarPrev, MbscCalendarInvalid, MbscCalendarEventData, MbscResource } from '@mobiscroll/react';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

import WrapTextIcon from '@mui/icons-material/WrapText';
import EditIcon from "@mui/icons-material/Edit";
import AutoModeIcon from '@mui/icons-material/AutoMode';
import ClearIcon from '@mui/icons-material/Clear';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

import moment, { Moment } from 'moment';

import '../../css/Scheduler.css';

import { SalaAsignarProps } from '../../interfaces/catalogos/SalaInterface';
import { AsignacionAutomaticaProps, AudienciaProps, SeleccionarSalaParams, AudienciaSalaProps } from '../../interfaces/comun/AgendaInterface';
import { JuezSalaProps } from '../../interfaces/catalogos/JuezInterface';
import { AlertProps } from '../../interfaces/global/AlertInterface';

import { AsignarSala, AsignarSalaAutomatica, FinalizarAsignacionSala, ObtenerAgendaSala } from '../../connections/comun/AgendaConnection';
import { ObtenerSala } from '../../connections/catalogos/SalaConnection';
import { GetContrastTextColor } from '../../helpers/GetContrastTextColor';

const now = new Date();
const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);

setOptions({
    locale: localeEs,
    theme: 'ios',
    themeVariant: 'light'
});

const isWeekend = (date: Moment) => {
    const day = date.day();

    return day === 0 || day === 6;
};

interface TaskProps {
    solicitud: AudienciaSalaProps;
    handleOpen: () => void;
}

function Task({ solicitud, handleOpen }: TaskProps) {

    const { tipoAudiencia, juez, color, horaInicio, horaFin } = solicitud;

    const time = formatDate('hh:mm A', moment(horaInicio).toDate()) + ' - ' + formatDate('hh:mm A', moment(horaFin).toDate());

    return (
        <div>
            {
                <div className="external-drop-task" style={{ background: color }}>

                    <Typography textAlign={'start'} variant='h6' fontSize={18} sx={{ color: GetContrastTextColor( color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }}>{tipoAudiencia}</Typography>

                    <Grid container spacing={3}>
                        <Grid size={3}> <Typography variant='body2' sx={{ color: GetContrastTextColor( color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} fontWeight={'bold'} mt={2}>Juez:</Typography> </Grid>
                        <Grid size={9}> <Typography variant='body2' sx={{ color: GetContrastTextColor( color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} mt={2}>{juez}</Typography> </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid size={3}> <Typography variant='body2' sx={{ color: GetContrastTextColor( color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} fontWeight={'bold'} mt={2}>Hora:</Typography> </Grid>
                        <Grid size={9}> <Typography variant='body2' sx={{ color: GetContrastTextColor( color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} mt={2}>{time}</Typography> </Grid>
                    </Grid>
                    {
                        ( moment(horaInicio).format('YYYY-MM-DD') >= moment(horaFin).format('YYYY-MM-DD') )
                        &&
                            <Button fullWidth startIcon={<WrapTextIcon />} variant='outlined' sx={{ mt: 2, borderColor: GetContrastTextColor( color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000', color: GetContrastTextColor( color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} onClick={handleOpen}>
                                Asignar sala
                            </Button>
                    }
                </div>
            }
        </div>
    );
}

const defaultSelectedAudiencia: AudienciaProps = { idAgenda: 0, duracion: 0, idEstatus: 0, idJuez: 0, juez : '', idSecretario: 0, secretario: '', numeroExpediente : '', solicitante: '', tipoAudiencia: '' };

export const AsignarSalaPage = () => {

    const [audienciaSelected, setAudienciaSelected] = useState<AudienciaProps>( defaultSelectedAudiencia );
    const [audienciaSelectedTime, setAudienciaSelectedTime] = useState('');

    const [isTooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipAnchor, setTooltipAnchor] = useState();

    const [sala, setSala] = useState(0);
    const [salaArray, setSalaArray] = useState<SalaAsignarProps[]>([]);

    const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

    const [open, setOpen] = useState<boolean>(false);
    const [openEvento, setOpenEvento] = useState<boolean>(false);
    const [openConfirmacion, setOpenConfirmacion] = useState<boolean>(false);

    const [loadingData, setLoadingData] = useState<boolean>(true);
    const [loadingButton, setLoadingButton] = useState<boolean>(false);
    const [loadingAsignacionAutomatica, setLoadingAsignacionAutomatica] = useState<boolean>(false);

    const [juezArray, setJuezArray] = useState<JuezSalaProps[]>([]);

    const [audiencias, setAudiencias] = useState<AudienciaProps[]>([]);
    const [pendientes, setPendientes] = useState<AudienciaSalaProps[]>([]);

    const [selectedDate, setSelectedDate] = useState<MbscDateType>(moment(now).format('YYYY-MM-DD'));

    const [alert, setAlert] = useState<AlertProps>({ open: false, msg: "", type: "warning" });

    const myInvalid: MbscCalendarInvalid[] = useMemo(() =>
        [{
            recurring: {
                repeat: 'daily',
                until: yesterday,
            },
            cssClass: 'md-lunch-break-class mbsc-flex',
        },], [],
    );

    const myHeader = useCallback(
        () => (
            <Grid container spacing={3} mt={1} sx={{ width: '100%', p: 1 }}>

                <Grid size={4}>

                    <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale='es'>
                        <DatePicker
                            sx={{ width: '100%' }}
                            shouldDisableDate={ isWeekend }
                            value={ moment(selectedDate) }
                            onChange={ (e) => setSelectedDate( moment(e, "dd/MM/yyyy") ) }
                        />
                    </LocalizationProvider>

                </Grid>

                <Grid size={3} textAlign={'end'}>
                    <CalendarPrev />
                    <CalendarToday />
                    <CalendarNext />
                </Grid>

                <Grid size={5} textAlign={'end'}>
                   
                    <Button type="button" disabled={ loadingData || pendientes.length !== 0 || audiencias.length === audiencias.filter( e => e.idEstatus === 7 ).length } variant='contained' onClick={() => { setOpen(true) }} >
                        Finalizar asignación
                    </Button>                    

                </Grid>

            </Grid>
        ),
        [ selectedDate, pendientes, audiencias, loadingData ],
    );

    const customScheduleEvent = useCallback( ( data: MbscCalendarEventData ) => {
 
        if ( data.allDay ) {

            return (
                <div style={{ background: data.color }} className="md-custom-event-allday-title">
                    {data.title}
                </div>
            );
        } 
        else {

            const estatus = audiencias.find( (e) => e.id === data.id )?.idEstatus;

            return (
                <div className="md-custom-event-cont" style={{ borderLeft: '5px solid ' + data.color, background: data.color }}>
            
                    <div className="md-custom-event-wrapper">

                        <Grid container px={1} pt={1}>

                            <Grid size={10}>
                                <Typography variant='body1' sx={{ color: GetContrastTextColor( data.color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} fontSize={12}> { data.title } </Typography>                               
                            </Grid>

                            {
                                estatus === 7
                                &&
                                    <Grid size={2}>
                                        <DoneAllIcon fontSize='small' sx={{ color: GetContrastTextColor( data.color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} />     
                                    </Grid>
                            }

                            <Grid size={12}>
                                <Typography variant='body1' sx={{ color: GetContrastTextColor( data.color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} fontSize={10}> { data.start?.toString() } - { data.end?.toString() } </Typography>  
                            </Grid>

                        </Grid>   
                         
                    </div>

                </div>
            );
        }
    }, [ audiencias ]);

    const renderCustomResource = useCallback( (resource: MbscResource ) => (

            <Grid container spacing={0}>

                <Grid size={12} my={1}>{ <AccountBalanceIcon fontSize='large' /> }</Grid>   
                <Grid size={12}><Typography variant='h6' fontSize={16}>{ resource.name }</Typography></Grid>

            </Grid>

        ), [],
    );

    const myView = useMemo<MbscEventcalendarView>(
        () =>
            ({
                schedule: {
                    type: 'day',
                    startTime: '08:00',
                    endTime: '16:00',
                    allDay: false,
                    startDay: 1,
                    endDay: 5,
                    timeCellStep: 30,
                    timeLabelStep: 30,
                    currentTimeIndicator: false,
                },
            }),
        [],
    );

    const openTooltip = useCallback((args: MbscEventClickEvent) => {

        const event: MbscCalendarEvent = args.event;
        const time = formatDate('hh:mm A', new Date(event.start! as string)) + ' - ' + formatDate('hh:mm A', new Date(event.end! as string));

        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = undefined;
        }

        var audiencia = audiencias.find((e) => e.id === event.id);

        if( audiencia ){
            
            setAudienciaSelected( audiencia );
            
            setAudienciaSelectedTime( time );
            setTooltipAnchor(args.domEvent.target.closest('.mbsc-schedule-event'));
    
            setTooltipOpen(true);
        }

    }, [audiencias]);

    const handleEventDragStart = useCallback(() => {
        setTooltipOpen(false);
    }, []);

    const handleCloseAlert = ( _: any, reason: any ) => {

        if (reason === 'clickaway') {
            return;
        }

        setAlert({ open: false, type: "warning" });
    }

    const handleOpenSolicitud = ( pendiente: AudienciaSalaProps ) => {

        setOpenEvento(true);

        var itStart: number;
        var itEnds: number;

        if ( pendiente ) {
            
            itStart = ( moment( pendiente.horaInicio ).hours() * 60 + moment( pendiente.horaInicio ).minutes() )
            itEnds = ( moment( pendiente.horaFin ).hours() * 60 + moment( pendiente.horaFin ).minutes())

            setAudienciaSelected({ 
                ...pendiente, 
                title: pendiente.tipoAudiencia, 
                start: pendiente.horaInicio, 
                end: pendiente.horaFin, 
                id: pendiente.idAgenda, 
                idEstatus: pendiente.idEstatus, 
            });
        }

        var salasFiltro = salaArray;

        audiencias?.forEach(e => {

            const start = moment(e.start).hours() * 60 + moment(e.start).minutes()
            const end = moment(e.end).hours() * 60 + moment(e.end).minutes()

            if (itStart >= start && itStart < end && e.id !== pendiente?.idAgenda ) {
                salasFiltro = salasFiltro.filter( id => id.id !== e?.resource )
            }
            else if (itStart < start && itEnds > start && e.id !== pendiente?.idAgenda ) {
                salasFiltro = salasFiltro.filter(id => id.id !== e?.resource)
            }
            
        })

        setSalaArray( salasFiltro );
    }

    const handleEventClick = useCallback(
        (args: MbscEventClickEvent) => {
            openTooltip(args);
        },
        [openTooltip],
    );

    const handleAsignarSala = async () => {

        setLoadingButton(true)

        var params: SeleccionarSalaParams = {
            idAgenda: audienciaSelected?.id ? parseInt(audienciaSelected.id.toString()) : 0,
            idSala: sala
        }

        await AsignarSala(params).then(resp => {

            if (resp.success) {

                setTimeout(() => {

                    if ( audienciaSelected?.resource !== undefined ) {

                        const newEvents = audiencias.map(elem => {
                            if (elem.id === audienciaSelected?.id) {
                                elem.resource = sala;
                                elem.idSala = sala;
                            }
                            return elem;
                        });

                        setAudiencias(newEvents);
                    }
                    else {
                        setAudiencias([...audiencias, { ...audienciaSelected, resource: sala, idSala: sala, }])
                    }

                    setPendientes( pendientes.filter(id => id.idAgenda !== audienciaSelected?.id) )

                    setAlert({ open: true, msg: resp.message, type: "success" });

                    setOpenEvento(false);

                    setLoadingButton(false);

                    setSala(0)

                }, 700);
            }
            else {

                setAlert({ open: true, msg: resp.message, type: "error" });

                setLoadingButton(false)
            }

        });

    }

    const handleFinalizarAsignacion = async () => {

        setLoadingButton(true)

        const newArray = audiencias.filter( e => e.idEstatus === 6 ).map( a => { return parseInt( a.id?.toString() ?? '0'); });

        await FinalizarAsignacionSala( { audiencias: newArray } ).then(resp => {

            if (resp.success) {

                setTimeout(() => {

                    const newEvents = audiencias.map(elem => {
                        elem.idEstatus = 7;
                        return elem;
                    });

                    setAudiencias(newEvents)

                    setAlert({ open: true, msg: resp.message, type: "success" });

                    setLoadingButton(false);

                    setOpen(false)

                }, 700);
            }
            else {

                setAlert({ open: true, msg: resp.message, type: "error" });

                setLoadingButton(false)
            }

        });

    }

    const handleAsignarSalaAutomatica = async () => {

        setLoadingAsignacionAutomatica(true)

        const newArray: AsignacionAutomaticaProps[] = pendientes.map( a => { 
            return {
                idAgenda: parseInt( a.idAgenda?.toString() ?? '0'),
                idJuez:   a.idJuez,
            }; 
        });

        await AsignarSalaAutomatica( { fecha: moment( selectedDate ).toDate(), audiencias: newArray } ).then( resp => {

            const { success, message, agenda } = resp;

            if ( success ) {

                setTimeout(() => {

                    const newArrayEvents: AudienciaProps[] = agenda.filter(e => e.idSala !== 0).map(agenda => {

                        const color = juezArray.find( (e) => e.idJuez === agenda.idJuez)?.color;

                        return {
                            id: agenda.idAgenda,
                            idAgenda: agenda.idAgenda,
                            idJuez: agenda.idJuez,
                            juez: agenda.juez,                           
                            idSecretario: agenda.idSecretario,
                            secretario: agenda.secretario,
                            solicitante: agenda.solicitante,
                            numeroExpediente: agenda.numeroExpediente,                            
                            tipoAudiencia: agenda.tipoAudiencia,
                            duracion: agenda.duracion,
                            idEstatus: agenda.idEstatus,
                            fechaLiberacion: agenda.fechaLiberacion,
                            idSala: agenda.idSala ?? 0,

                            title: agenda.tipoAudiencia,
                            end: moment(agenda.fechaFin),
                            start: moment(agenda.fechaInicio),
                            resource: agenda.idSala,                            
                            color: color ?? '',
                        };
                    });     
                    
                    const newArrayPendientes: AudienciaSalaProps[] = agenda.filter(e => e.idSala === 0).map(agenda => {
                        return {
                            idAgenda: agenda.idAgenda ?? 0,
                            juez: agenda.juez ?? '',
                            idJuez: agenda.idJuez ?? 0,
                            tipoAudiencia: agenda.tipoAudiencia ?? '',
                            horaInicio: agenda.fechaInicio,
                            horaFin: agenda.fechaFin,
                            solicitante: agenda.solicitante ?? '',
                            numeroExpediente: agenda.numeroExpediente ?? '',
                            color: agenda.color ?? '',
                            idSolicitante: agenda.idSolicitante ?? 0,
                            idEstatus: agenda.idEstatus ?? 0,
                            idSecretario: agenda.idSecretario,
                            secretario: agenda.secretario,
                            duracion: agenda.duracion,
                            idSala: agenda.idSala ?? 0,
                        };
                    })          

                    setAudiencias([ ...newArrayEvents, ...audiencias ]);
                    setPendientes( newArrayPendientes );

                    setAlert({ open: true, msg: message, type: "success" });

                    setLoadingAsignacionAutomatica(false);

                    setOpenConfirmacion(false)

                }, 700);
            }
            else {

                setAlert({ open: true, msg: resp.message, type: "error" });

                setLoadingAsignacionAutomatica(false)
            }

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerSala().then( resp => {
                setSalaArray( resp );  
            });
        }

        Obtener()

    }, [])

    useEffect(() => {

        async function Obtener() {

            setLoadingData(true)
            setJuezArray([])

            await ObtenerAgendaSala({ fecha: moment( selectedDate ).toDate() }).then(resp => {

                setTimeout(() => {

                    const { juezArray, agenda } = resp;

                    const newJuezArray: JuezSalaProps[] = juezArray.map( item => {
                        return {
                            idJuez: item.idJuez,
                            nombre: item.nombre,
                            color: item.color,
                            opacityColor: item.opacityColor,
                        }
                    });                    

                    const newArrayPendientes: AudienciaSalaProps[] = agenda.filter(e => e.idSala === 0).map(agenda => {
                        return {
                            idAgenda: agenda.idAgenda ?? 0,
                            juez: agenda.juez ?? '',
                            idJuez: agenda.idJuez ?? 0,
                            tipoAudiencia: agenda.tipoAudiencia ?? '',
                            horaInicio: agenda.fechaInicio,
                            horaFin: agenda.fechaFin,
                            solicitante: agenda.solicitante ?? '',
                            numeroExpediente: agenda.numeroExpediente ?? '',
                            color: agenda.color ?? '',
                            idSolicitante: agenda.idSolicitante ?? 0,
                            idEstatus: agenda.idEstatus ?? 0,
                            idSecretario: agenda.idSecretario,
                            secretario: agenda.secretario,
                            duracion: agenda.duracion,
                            idSala: agenda.idSala ?? 0,
                            sala: agenda.sala ?? '',
                        };
                    });                    

                    const newArrayEvents: AudienciaProps[] = agenda.filter(e => e.idSala !== 0).map(agenda => {
                        return {
                            id: agenda.idAgenda,
                            idAgenda: agenda.idAgenda,
                            idJuez: agenda.idJuez,
                            juez: agenda.juez,                           
                            idSecretario: agenda.idSecretario,
                            secretario: agenda.secretario,
                            solicitante: agenda.solicitante,
                            numeroExpediente: agenda.numeroExpediente,                            
                            tipoAudiencia: agenda.tipoAudiencia,
                            duracion: agenda.duracion,
                            idEstatus: agenda.idEstatus,
                            fechaLiberacion: agenda.fechaLiberacion,
                            idSala: agenda.idSala ?? 0,
                            sala: agenda.sala ?? '',
                            
                            title: agenda.tipoAudiencia,
                            end: moment(agenda.fechaFin),
                            start: moment(agenda.fechaInicio),
                            resource: agenda.idSala,
                            color: agenda.color,
                        };
                    });

                    setJuezArray( newJuezArray );
                    setPendientes( newArrayPendientes );
                    setAudiencias( newArrayEvents );

                    setLoadingData( false );

                }, 700);

            });

        }

        Obtener()

    }, [selectedDate])

    return (
        <div className="mbsc-grid mbsc-no-padding">

            {
                alert.msg
                &&
                    <Snackbar open={alert.open} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} autoHideDuration={2000} onClose={handleCloseAlert}>
                        <Alert onClose={() => handleCloseAlert} variant="filled" severity={alert.type} sx={{ width: '100%' }}>
                            {alert.msg}
                        </Alert>
                    </Snackbar>
            }

            {

                <Grid container spacing={3} mt={1}>

                    <Grid size={12}>

                        <Grid container spacing={3} mt={1}>

                            <Grid size={8}>
                                
                                <Grid container spacing={3}>

                                    {
                                        loadingData
                                        ?
                                            <Grid size={12} textAlign={'center'} alignContent={'center'}>    
                                                <CircularProgress size={32} />    
                                            </Grid>
                                        :                                            
                                            <>
                                                {
                                                    juezArray
                                                    .map(({ nombre, color, opacityColor }, index) => (
                                                        <Grow 
                                                            key={index}
                                                            in={true}
                                                            style={{ transformOrigin: '0 0 0' }}
                                                            {...(true ? { timeout: 1000 } : {})}
                                                        >
                                                            <Grid size={3}>
                                                                <Card sx={{ bgcolor: opacityColor, boxShadow: 'none' }}>
                                                                    <CardHeader
                                                                        avatar={<Avatar sx={{ bgcolor: color, width: 35, height: 35, fontSize: 14 }} aria-label="recipe"> { nombre.substring(0, 1) } </Avatar>}
                                                                        title={<Typography variant='body2' fontSize={12} sx={{ color: GetContrastTextColor( color ?? 'rgba(0, 0, 0)' ) === 'white' ? '#fff': '#000' }}> {nombre} </Typography>}
                                                                        sx={{ p: 1 }}
                                                                    />
                                                                </Card>
                                                            </Grid>
                                                        </Grow>
                                                    ))
                                                }
                                            </>                                        
                                    }
                                
                                </Grid>

                            </Grid>

                            <Grid size={4} textAlign={'end'}>
                              
                                <Button disabled={ pendientes.length === 0 } type="button" variant='contained' startIcon={ <AutoModeIcon /> } onClick={ () => setOpenConfirmacion( true ) } >
                                    Asignar salas automaticamente
                                </Button>                                

                            </Grid>

                        </Grid>

                    </Grid>

                    <Grid size={12} mt={1}>

                        <div className="mbsc-row">

                            <div className="mbsc-col-sm-9 external-drop-calendar">

                                <Eventcalendar
                                    selectedDate={selectedDate}
                                    data={audiencias}
                                    view={myView}
                                    resources={ salaArray }
                                    invalid={myInvalid}
                                    dragToCreate={false}
                                    eventOverlap={false}
                                    externalDrop={false}
                                    externalDrag={false}
                                    eventDelete={false}
                                    onEventClick={handleEventClick}
                                    onEventDragStart={handleEventDragStart}
                                    renderHeader={myHeader}
                                    renderScheduleEvent={ customScheduleEvent }
                                    renderResource={renderCustomResource}
                                    onSelectedDateChange={(e) => setSelectedDate(moment(e.date).format('YYYY-MM-DD'))}
                                />

                                <Popup
                                    anchor={tooltipAnchor}
                                    contentPadding={false}
                                    display="anchored"
                                    isOpen={isTooltipOpen}
                                    scrollLock={false}
                                    showOverlay={false}
                                    touchUi={false}
                                    width={350}
                                >
                                    <div className="mds-tooltip">
    
                                        <div className="mds-tooltip-header" style={{ backgroundColor: '#4D4D50' }}>
                                            <Typography variant='body2' fontSize={18} textAlign={'center'}>{audienciaSelected?.title}</Typography>
                                            <Typography variant='body2' fontSize={14} sx={{ textAlign: "center", mt: 1 }} >{audienciaSelectedTime}</Typography>
    
                                            <IconButton  size='small' sx={{ position: 'absolute', top: 10, right: 10, border: '1px solid white' }} onClick={ () => setTooltipOpen( false ) }>
                                                <ClearIcon sx={{ color: 'white', fontSize: 16 }} />
                                            </IconButton>
    
                                            {
                                                ( moment(audienciaSelected?.start).format('YYYY-MM-DD') > moment(yesterday).format('YYYY-MM-DD') && audienciaSelected?.idEstatus !== 7 )
                                                &&
                                                    <IconButton
                                                        size='small'
                                                        sx={{ position: 'absolute', top: 45, right: 10, border: '1px solid white' }}
                                                        onClick={ () => { setOpenEvento( true ); setTooltipOpen( false ); setSala( audienciaSelected.idSala ?? 0 ); } }
                                                    >
                                                        <EditIcon sx={{ color: 'white', fontSize: 16 }} />
                                                    </IconButton>
                                            }
    
                                        </div>
    
                                        <Box sx={{ p: 2, mt: -1 }}>
    
                                            <Grid container spacing={0}>                                            
                                                <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Juez(a):</Typography> </Grid>
                                                <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.juez}</Typography> </Grid>  
                                            </Grid>
    
                                            <Grid container spacing={0} mt={2}>
                                                <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Secretario(a):</Typography> </Grid>
                                                <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.secretario}</Typography> </Grid>
                                            </Grid>
    
                                            <Grid container spacing={0} mt={2}>
                                                <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Número expediente:</Typography> </Grid>
                                                <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.numeroExpediente}</Typography> </Grid>
                                            </Grid>
    
                                            {
                                                audienciaSelected?.solicitante
                                                &&
                                                    <Grid container spacing={0} mt={2}>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Solicitante:</Typography> </Grid>
                                                        <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.solicitante}</Typography> </Grid>
                                                    </Grid>
                                            }           

                                            {
                                                audienciaSelected?.sala
                                                &&
                                                    <Grid container spacing={0} mt={2}>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Sala asignada:</Typography> </Grid>
                                                        <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.sala}</Typography> </Grid>
                                                    </Grid>
                                            }                                                                 
    
                                        </Box>
    
                                    </div>
    
                                </Popup>

                            </div>

                            <div className="mbsc-col-sm-3 external-drop-cont" style={{ padding: 10 }}>

                                <Box textAlign={'center'}>
                                    <Typography variant='h6' className="mbsc-form-group-title" my={2}>
                                        Audiencias pendientes <br /> para asignar
                                    </Typography>
                                </Box>

                                <Divider />

                                {
                                    !loadingData
                                    &&
                                        <Box sx={{ maxHeight: '95vh', overflowY: pendientes.length === 0 ? 'hidden' : 'scroll' }}>

                                            {
                                                pendientes
                                                .map((task) => (
                                                    <Task
                                                        key={ task.idAgenda }
                                                        solicitud={ task }
                                                        handleOpen={ () => handleOpenSolicitud( task ) }
                                                    />
                                                ))
                                            }

                                            {
                                                ( pendientes.length === 0 )
                                                &&
                                                    <Box sx={{ height: '95vh' }} textAlign={'center'}>
                                                        <Typography variant='body2' color='textSecondary' sx={{ mt: 10 }}>
                                                            No se encontraron audiencias
                                                        </Typography>
                                                    </Box>
                                            }

                                        </Box>
                                }

                                {
                                    loadingData
                                    &&
                                        <Grid size={12} textAlign={'center'} alignContent={'center'} height={700}>    
                                            <CircularProgress size={32} />    
                                        </Grid>
                                }

                            </div>

                        </div>

                    </Grid>

                </Grid>
            }

            <Dialog
                open={ openEvento }
                onClose={ () => { } }
                disableEscapeKeyDown
                maxWidth='sm'
            >
                <DialogTitle>
                    Asignar sala de audiencia
                </DialogTitle>

                <DialogContent sx={{ width: 420 }}>

                    <Box sx={{ mt: 1 }}>

                        <Grid container spacing={3}>

                            <Grid size={{ xs: 12, md: 12 }}>

                                <Grid container spacing={0}>

                                    <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Tipo de audiencia:</Typography> </Grid>
                                    <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.title}</Typography> </Grid>

                                    <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Hora:</Typography> </Grid>
                                    <Grid size={12}> <Typography variant='body2' color='black'>{formatDate('hh:mm A', moment(audienciaSelected?.start).toDate()) + ' - ' + formatDate('hh:mm A', moment(audienciaSelected?.end).toDate())}</Typography> </Grid>

                                    <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Juez(a):</Typography> </Grid>
                                    <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.juez}</Typography> </Grid>
                                 
                                    <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Secretario(a):</Typography> </Grid>
                                    <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.secretario}</Typography> </Grid>

                                    <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Número expediente:</Typography> </Grid>
                                    <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.numeroExpediente}</Typography> </Grid>

                                    {
                                        audienciaSelected?.solicitante
                                        &&
                                        <>
                                            <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Solicitante:</Typography> </Grid>
                                            <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.solicitante}</Typography> </Grid>                                           
                                        </>
                                    }
                                  
                                    <Grid size={12} mt={3}>

                                        <FormControl fullWidth>

                                            <TextField
                                                id="select-tipo-sala"
                                                label="Sala"
                                                select
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                }}
                                                value={sala}
                                                disabled={loadingButton}
                                                onChange={(e) => setSala(parseInt(e.target.value))}
                                            >
                                                <MenuItem value={0}>Seleccione una opción</MenuItem>
                                                {
                                                    salaArray.filter(a => a.activo === true).map((e) => (
                                                        <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>
                                                    ))
                                                }
                                            </TextField>

                                        </FormControl>

                                    </Grid>

                                </Grid>

                            </Grid>

                        </Grid>

                    </Box>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={loadingButton} onClick={ () => { setOpenEvento(false); setSala(0) } }>
                        Cancelar
                    </Button>

                    <Button variant='contained'
                        onClick={ handleAsignarSala }
                        loading={ loadingButton }
                        disabled={ sala === 0 }
                    >
                        Guardar 
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={ open } onClose={ () => { } } >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea finalizar la asignación de salas?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button
                        color='secondary' 
                        onClick={ () => setOpen(false) }
                        disabled={ loadingButton }
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant='contained'
                        color='primary'
                        onClick={ handleFinalizarAsignacion }
                        loading={ loadingButton }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={ openConfirmacion } onClose={ () => { } } >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea activar la asignación de salas automatica?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button
                        color='secondary' 
                        onClick={ () => setOpenConfirmacion(false) }
                        disabled={ loadingAsignacionAutomatica }
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant='contained'
                        color='primary'
                        onClick={ handleAsignarSalaAutomatica }
                        loading={ loadingAsignacionAutomatica }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

        </div>
    );
};